var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.86 2.20316C12.5807 1.94595 12.1532 1.93808 11.8646 2.18485L2.5126 10.1811C2.34595 10.3236 2.25 10.5319 2.25 10.7512V21.7498C2.25 22.164 2.58579 22.4998 3 22.4998H7.75V18.9912C7.75 16.644 9.65279 14.7412 12 14.7412C14.3472 14.7412 16.25 16.644 16.25 18.9912V22.4998H21C21.4142 22.4998 21.75 22.164 21.75 21.7498V10.718C21.75 10.5083 21.6623 10.3083 21.508 10.1663L12.86 2.20316ZM10.8898 1.04477C11.7556 0.304478 13.0381 0.32807 13.8761 1.0997L22.5241 9.0628C22.9868 9.48883 23.25 10.0891 23.25 10.718V21.7498C23.25 22.9924 22.2426 23.9998 21 23.9998H14.75V18.9912C14.75 17.4724 13.5188 16.2412 12 16.2412C10.4812 16.2412 9.25 17.4724 9.25 18.9912V23.9998H3C1.75736 23.9998 0.75 22.9924 0.75 21.7498V10.7512C0.75 10.0934 1.03785 9.46851 1.5378 9.04104L10.8898 1.04477Z",
    fill: "#0C0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6c5c2c3ed50aa97324d77fa717dd8d7d.svg";
export { ForwardRef as ReactComponent };